const assetsPath = 'https://gcc-component-assets.s3.amazonaws.com/countertops';
export default assetsPath;